import { AnchorButton, Button } from '@payaca/ambrosia';
import { Link } from 'react-router-dom';
import BasicPageWrapper from '../pageWrappers/basicPageWrapper/BasicPageWrapper';
import './404.sass';

import useLogout from '@/hooks/auth/useLogout';
import SadFaceIcon from './sad-face.svg';

import type { JSX } from 'react';

const FourOhFourPage = (): JSX.Element => {
  const logout = useLogout();

  return (
    <BasicPageWrapper className="four-oh-four-page">
      <div className="information-wrapper">
        <div className="sad-face">
          <img src={SadFaceIcon} />
        </div>
        <div className="information-container">
          <h1>404</h1>
          <h2>Page not found</h2>
          <div className="mt-8 flex flex-col items-center gap-4">
            <AnchorButton as={Link} to="/">
              Return to dashboard
            </AnchorButton>
            <Button variant="link" onClick={logout}>
              Log out
            </Button>
          </div>
        </div>
      </div>
    </BasicPageWrapper>
  );
};

export default FourOhFourPage;
